"use strict";

angular.module("extra2App").directive("ckTiers", [
  "$location",
  "restservice",
  "page",
  "$translatePartialLoader",
  "$translate",
  "adminservice",
  function (
    $location,
    restservice,
    page,
    $translatePartialLoader,
    $translate,
    adminservice,
  ) {
    return {
      templateUrl: "views/directives/tiers.html",
      restrict: "E",
      scope: { module: "=" },
      link: function (scope) {
        $translatePartialLoader.addPart("tier");
        $translate.refresh();

        scope.tiersData = scope.module[1];
        scope.messages = scope.module[1].profile.messages;
        scope.profile = scope.module[1].profile;

        scope.currentLevel =
          scope.profile.currentLevel === 0 ? 1 : scope.profile.currentLevel;
        scope.iconsBasePath = restservice.getIconsBasePath();
        scope.parachute = scope.profile.parachute ? "_parachute" : "";
        scope.levelIcon =
          "images/tiers/tier_all_" +
          scope.currentLevel +
          scope.parachute +
          ".svg";
        scope.levels = scope.module[1].levels;
        scope.levels_title = scope.module[1].levels_title;

        scope.goToInfo = function () {
          localStorage.setItem("tiers_levels", JSON.stringify(scope.levels));
          localStorage.setItem(
            "levels_title",
            JSON.stringify(scope.levels_title),
          );
          $location.path("/tiers-info");
        };

        scope.goToTiersTransactions = function () {
          $location.path("/tiers-transactions");
        };

        scope.hiddenBUs = ["PL", "LT", "LV", "EE", "DK", "NO"]; //List of BUs which dashboard shouldn't display rolling model and fuel consumption components
        var initialBu = (
          adminservice.getBu() ||
          localStorage.getItem("businessUnit") ||
          ""
        ).toUpperCase();
        scope.bu = initialBu;
        scope.isElementDisplayed = !scope.hiddenBUs.includes(scope.bu);

        scope.$watch(
          function () {
            return adminservice.getBu() || localStorage.getItem("businessUnit");
          },
          function (newBu) {
            if (newBu) {
              scope.bu = newBu.toUpperCase();
              scope.isElementDisplayed = !scope.hiddenBUs.includes(scope.bu);
            }
          },
        );
      },
    };
  },
]);

angular.module("extra2App").filter("trust_as_html", [
  "$sce",
  function ($sce) {
    return function (input) {
      return $sce.trustAsHtml(input);
    };
  },
]);
